import { Typography } from '@mui/material';

type MemberDetailProps = {
  detail: string | undefined;
  small?: boolean;
};

export const MemberDetail = (props: MemberDetailProps) => {
  const { detail, small = false } = props;
  return (detail && <Typography variant={small ? 'body2' : 'body1'}>{detail}</Typography>) || <></>;
};
